export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user'
};
export const PARENTAL_CONTROLS_FIELDS = [
    'disableCommunity',
    'disableUserGeneratedContent',
    'disableLocation',
    'hideSensitiveInfo'
];
//# sourceMappingURL=user.js.map